<div class="kz-profilv2--header-media" [ngClass]="{'kz-profilv2--header-media-mini-cover': miniCover}">
  <kz-corner-ribbon *ngIf="pro.hasBoxService" cornerRibbonContext="box" cornerRibbonSize="small">Box</kz-corner-ribbon>
  <div class="kz-profilv2--header-media-video" *ngIf="pro.coverType == coverTypesEnum.Video && !!proVideoId">
    <app-video-player [video]="proVideoId" [gtmSuffix]="'pro'" [buttonSize]="(miniCover) ? 'small' : 'large'">
      <figure>
        <picture>
          <img [src]="'https://img.youtube.com/vi/' + proVideoId + '/0.jpg'"
               i18n-alt="@@pro.video.img.alt"
               alt=""/>
        </picture>
      </figure>
    </app-video-player>
  </div>
  <div class="kz-profilv2--header-media-carousel kz-diaporama-v2" data-current="1" data-nav="true" *ngIf="pro.coverType == coverTypesEnum.Photos && proCovers">
    <div class="kz-diaporama-container">
      <div class="kz-diaporama-item" [ngClass]="{'kz-diaporama-current' : (currentSlide$ | async) == i}" *ngFor="let cover of proCovers; let i = index;">
        <app-picture-source [imgSrc]="cover.contentUrl" [alt]="''"
                            [presets]="'pro-item' | imgPreset"
                            width="565" height="325"
                            imgFitHeight="true"
                            [bgBlur]="true"
                            [mediaQueries]="[{mediaQuery: '(max-width: 420px)', settings: 'pro-item' | imgPreset : 'xs'}]"
                            useWebp="true" useLazyLoad="true"
                            handleX2="true" [handleX3]="false"
                            [preloadImages]="preloadImages && (i == 0)"
                            [fetchPriority]="fetchPriority && (i == 0)"
        ></app-picture-source>
      </div>
    </div>
    <div class="kz-diaporama--nav">
      <app-diapo-button *ngIf="(currentSlide$ | async) > 0" (click)="currentSlide = currentSlide - 1"></app-diapo-button>
      <app-diapo-button [direction]="'next'" *ngIf="(currentSlide$ | async) < (pro.covers.length - 1)" (click)="currentSlide = currentSlide + 1"></app-diapo-button>
    </div>
  </div>
</div>
